import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import EditPanel from "../components/EditPanel";
import TodoListComponent from "../components/TodoListComponent";
import { useTodo } from "../Contexts/TodoProvider";
import { useUser } from "../Contexts/UserProvider";

function TodoPage() {
  const { showEdit } = useTodo();
  const { user, loading } = useUser();

  const navigate = useNavigate();

  useEffect(() => {
    console.log("TodoPage", user);
    if (!loading && user === null) {
      navigate("/get-started");
    }
  }, []);

  return (
    <div className="flex flex-row flex-1  bg-neutral-900 ">
      <TodoListComponent />
      {!(showEdit === null) && <EditPanel />}
    </div>
  );
}

export default TodoPage;
